export default __webpack_public_path__ + "static/media/Maple Leafs.f9490dab.png";